import { notify } from 'reapop';
import { notificationConfig } from '../utils/helpers/general';

export const successRequestUpdateNotification = () =>
  notify(
    notificationConfig('Satisfactorio', 'Información actualizada!', 'success')
  );

export const errorRequestUpdateNotification = () =>
  notify(
    notificationConfig(
      'Error',
      'No se pudo actualizar la información!',
      'error'
    )
  );
export const errorRequestUpdateNotificationRepresentative = () =>
  notify(
    notificationConfig(
      'Error',
      'No se pudo actualizar la información requiere agregar un representante!',
      'error'
    )
  );
export const errorRequestUpdateNotificationDataSOC = () =>
  notify(
    notificationConfig(
      'Error',
      'Faltan datos, favor verificar que esta solicitud contenga email, CURP y tipo de persona',
      'error'
    )
  );
export const successDiscountAppliedNotification = () =>
  notify(
    notificationConfig(
      'Satisfactorio',
      'Descuento aplicado satisfactoriamente!',
      'success'
    )
  );
export const successGeneralNotification = () =>
  notify(
    notificationConfig('Satisfactorio', 'Información actualizada!', 'success')
  );
export const errorGeneralNotification = () =>
  notify(notificationConfig('Error', 'Error inesperado!', 'error'));

export const contractCreatedNotification = () =>
  notify(notificationConfig('Satisfactorio', 'Contrato creado!', 'success'));
export const successNotification = message =>
  notify(notificationConfig('Satisfactorio', message, 'success'));
export const wrongUsernameOrPasswordNotification = () =>
  notify(
    notificationConfig('Error', 'Correo o contraseña incorrectas', 'error')
  );

export const customNotification = (title, message, type) =>
  notify(notificationConfig(title, message, type));

export const updateAvailableNotification = () => window.location.reload();



// WEBPACK FOOTER //
// ./src/actions/notifications.js